import React from 'react';
import { dateFns } from '../../helpers';
// import { dateFns } from '../DateFnsUtils';

export function WidgetDate ({ date, format = 'dd/MM/yyyy' }) {
    return (<span>{dateFns.format(date, format)}</span>);
}

// WidgetDate.displayName = 'WidgetDate';
// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetDate.displayName = 'WidgetDate';
}
